import { SelectLanguage } from "@telluscompany/design-system";

import { usePersistLanguage } from "../hooks/usePersistLanguage";
import { useLocalization } from "../hooks/useLocalization";

export const LanguageSwitcher = () => {
  const { availableLanguages } = useLocalization();
  const persistLanguage = usePersistLanguage();

  return (
    <SelectLanguage
      items={availableLanguages}
      onChange={(languageCode) => {
        void persistLanguage(languageCode).catch(() => undefined);
      }}
    />
  );
};
